import { lazy } from "react";
const AdvertiseAr = lazy(() => import("../Components/Advertise.js").then(mod => ({ default: () => <mod.default lang="ar" /> })));
const AdvertiseEn = lazy(() => import("../Components/Advertise.js").then(mod => ({ default: () => <mod.default lang="en" /> })));
export const mainRoutes = [
    { path: "/en/", component: lazy(() => import("../Components/LandingPageEN/LandingPage")), },
    { path: "/en/all-calculators", component: lazy(() => import("../Components/En/All-Calculators.js")), },
    { path: "/ar/about/", component: lazy(() => import("../Components/Ar/About")), },
    { path: "/ar/advertise/", component: AdvertiseAr, },
    { path: "/en/advertise/", component: AdvertiseEn, },
    { path: "/en/", component: lazy(() => import("../Components/LandingPageEN/LandingPage")), },
    { path: "/en/about/", component: lazy(() => import("../Components/En/About")), },
    { path: "/ar/privacy/", component: lazy(() => import("../Components/Ar/Policy")), },
    { path: "/ar/all-calculators/", component: lazy(() => import("../Components/Ar/All-Calculators")), },
];